import { Transaction } from '../swagger/api';
import { ColorScheme } from '../layout/colorScheme';
import { getInvoiceStatusDisplayInfo } from './invoiceStatusUtils';

export type RowFillKind = 'white' | 'gray' | 'red' | 'green';

const ZEBRA_GRAY = '#f7f7f7';

export const TABLE_DIVIDER_CONTRAST_WHITE = ColorScheme.White;

function fillKindToBackground(kind: RowFillKind): string {
  switch (kind) {
    case 'white':
      return ColorScheme.White;
    case 'gray':
      return ZEBRA_GRAY;
    case 'red':
      return ColorScheme.OutstandingBackground;
    case 'green':
      return ColorScheme.CreditBackground;
    default:
      return ColorScheme.White;
  }
}

export function getPrivateTransactionRowFillKind(
  transaction: Transaction,
  index: number
): RowFillKind {
  const statusInfo = getInvoiceStatusDisplayInfo(
    {
      invoiceStatus: transaction.invoiceStatus as string,
      invoiceType: transaction.invoiceType,
      transactionType: transaction.transactionType,
      revenueOperationType: transaction.revenueOperationType,
      dueDate: transaction.dueDate
    },
    'private'
  );
  if (statusInfo.rowClassName === 'outstanding-row') return 'red';
  if (statusInfo.rowClassName === 'credit-row') return 'green';
  return index % 2 === 0 ? 'gray' : 'white';
}

export function getPrivateTableRowBorderTopColor(
  prevKind: RowFillKind | null,
  currKind: RowFillKind
): string {
  if (prevKind === null) {
    return 'transparent';
  }
  if (prevKind === 'white' || currKind === 'white') {
    return fillKindToBackground(currKind);
  }
  return TABLE_DIVIDER_CONTRAST_WHITE;
}
